"use client";

import React from "react";

// styles
import * as S from "./styles";

interface SwitchComponentProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const SwitchComponent = ({ checked, onChange }: SwitchComponentProps) => {
  return <S.SwitchStyled checked={checked} onCheckedChange={onChange} />;
};

export default SwitchComponent;
